module.exports = __webpack_public_path__ + "img/facebook-logo.66789de0.svg";